import types from "./types";

const INITIAL_STATE = {
  poList: null,
  poListError: null,
  poListLoading: false,

  //create
  createpo: null,
  createpoError: null,
  createpoLoading: false,

  //update
  updatepo: null,
  updatepoError: null,
  updatepoLoading: false,

  //delete
  deletepo: null,
  deletepoError: null,
  deletepoLoading: false,

  //single item
  singleItem: null,
};

const poReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_PO_START:
      return {
        ...state,
        poList: null,
        poListError: null,
        poListLoading: true,
      };
    case types.GET_PO_SUCCESS:
      return {
        ...state,
        poList: action.payload,
        poListLoading: false,
      };
    case types.GET_PO_ERROR:
      return {
        ...state,
        poListError: action.payload,
        poListLoading: false,
      };
    case types.GET_PO_RESET:
      return {
        ...state,
        poListError: null,
        poListLoading: false,
      };
    //create

    case types.CREATE_PO_START:
      return {
        ...state,
        createpo: null,
        createpoError: null,
        createpoLoading: true,
      };
    case types.CREATE_PO_SUCCESS:
      return {
        ...state,
        createpo: action.payload,
        createpoLoading: false,
      };
    case types.CREATE_PO_ERROR:
      return {
        ...state,
        createpoError: action.payload,
        createpoLoading: false,
      };
    case types.CREATE_PO_RESET:
      return {
        ...state,
        createpoError: null,
        createpoLoading: false,
      };
    //delete

    case types.DELETE_PO_START:
      return {
        ...state,
        deletepo: null,
        deletepoError: null,
        deletepoLoading: true,
      };
    case types.DELETE_PO_SUCCESS:
      return {
        ...state,
        deletepo: action.payload,
        deletepoLoading: false,
      };
    case types.DELETE_PO_ERROR:
      return {
        ...state,
        deletepoError: action.payload,
        deletepoLoading: false,
      };
    case types.DELETE_PO_RESET:
      return {
        ...state,
        deletepo: null,
        deletepoError: null,
        deletepoLoading: false,
      };

    //update
    case types.UPDATE_PO_START:
      return {
        ...state,
        updatepo: null,
        updatepoError: null,
        updatepoLoading: true,
      };
    case types.UPDATE_PO_SUCCESS:
      return {
        ...state,
        updatepo: action.payload,
        updatepoLoading: false,
      };
    case types.UPDATE_PO_ERROR:
      return {
        ...state,
        updatepoError: action.payload,
        updatepoLoading: false,
      };
    case types.UPDATE_PO_RESET:
      return {
        ...state,
        updatepo: null,
        updatepoError: null,
        updatepoLoading: false,
      };
    //singleItem
    case types.SINGLE_PO_START:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: true,
      };
    case types.SINGLE_PO_SUCCESS:
      return {
        ...state,
        singleItem: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_PO_ERROR:
      return {
        ...state,
        singleItemError: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_PO_RESET:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: false,
      };

    default:
      return { ...state };
  }
};

export default poReducer;

